import {
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material'

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    useToolbarStyles,
} from 'app/shared-components/SkyNetMasterDataGrid'
import useLabel from 'app/hooks/useLabel'

import useStyles from './TabsDropdown.styles'

type Props = {
    tabs: SkyNetTableTab[],
    value: number,
    onChange: (value: number) => void,
}

const TabsDropdown = ({
    tabs,
    value,
    onChange,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes, cx,
    } = useStyles()

    const {
        classes: toolbarClasses,
    } = useToolbarStyles()

    const handleChange = (event: SelectChangeEvent<number>) => {
        onChange(event.target.value)
    }

    const tabLabel = l(tabs[value].name)

    if (tabs.length === 1) {
        return (
            <div
                className={cx(classes.root, classes.singleOption, classes.text)}
                data-testid="single-tab"
            >
                {tabLabel}
            </div>
        )
    }

    return (
        <Select
            label={tabLabel}
            value={value}
            onChange={handleChange}
            variant="standard"
            className={cx(classes.root, classes.text, classes.select)}
            MenuProps={{
                classes: {
                    paper: toolbarClasses.dropdown,
                },
            }}
            IconComponent={KeyboardArrowDown}
        >
            {tabs.map((tab, i) => {
                return (
                    <MenuItem
                        key={tab.name}
                        value={i}
                        className={cx(
                            classes.text,
                            value === i ? classes.selectedOption : null,
                        )}
                    >
                        {l(tab.name)}
                    </MenuItem>
                )
            })}
        </Select>
    )
}

export default TabsDropdown
